<template>
  <TopBar />

  <div class="notfound-container">
    <!-- Floating 404 digits -->
    <div class="floating-404">
      <span>4</span>
      <span>0</span>
      <span>4</span>
    </div>

    <h2 class="notfound-title">Page Not Found</h2>
    <p class="notfound-text">
      Sorry, the page you’re looking for doesn’t exist or may have been moved.
    </p>

    <router-link to="/" class="home-btn">
      Go Back 
    </router-link>

    <!-- Decorative red shapes -->
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>
  </div>

  <DownBar />
</template>

<script>
import TopBar from '@/components/Home/Header/TopBar.vue'
import DownBar from '@/components/Home/Footer/DownBar.vue'

export default {
  name: 'NotFound',
  components: {
    TopBar,
    DownBar
  }
}
</script>

<style scoped>
.notfound-container {
  position: relative;
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  text-align: center;
  overflow: hidden;
  padding: 2rem;
  animation: fadeIn 0.8s ease-in;
  z-index: 1;
}

/* Floating 404 */
.floating-404 {
  display: flex;
  gap: 0.5rem;
  font-size: 8rem;
  font-weight: 800;
  color: #e53935; /* red */
  margin-bottom: 0.5rem;
  text-shadow: 0 0 15px rgba(229, 57, 53, 0.3);
}

.floating-404 span {
  display: inline-block;
  animation: floatUpDown 2.5s ease-in-out infinite;
}

.floating-404 span:nth-child(1) { animation-delay: 0s; }
.floating-404 span:nth-child(2) { animation-delay: 0.3s; }
.floating-404 span:nth-child(3) { animation-delay: 0.6s; }

/* Text styling */
.notfound-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.notfound-text {
  font-size: 1rem;
  color: #666;
  max-width: 450px;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

/* Red theme button */
.home-btn {
  background: #e53935;
  color: #fff;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 0 15px rgba(229, 57, 53, 0.4);
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.home-btn:hover {
  background: #c62828;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 0 20px rgba(229, 57, 53, 0.7);
}

/* Decorative red pastel shapes */
.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.12;
  z-index: 0;
  animation: moveShape 10s ease-in-out infinite alternate;
}

.shape-1 {
  width: 180px;
  height: 180px;
  background: #e53935;
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.shape-2 {
  width: 250px;
  height: 250px;
  background: #f44336;
  bottom: 15%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 130px;
  height: 130px;
  background: #c62828;
  bottom: 5%;
  left: 25%;
  animation-delay: 4s;
}

/* Animations */
@keyframes floatUpDown {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes moveShape {
  0% { transform: translate(0, 0) rotate(0deg); }
  100% { transform: translate(20px, -20px) rotate(45deg); }
}
</style>
